module.exports = __webpack_public_path__ + "static/usa-0157fb6dbb4f4a2372791c528656eb1f.svg";